jQuery(($) => {
	$(".accord:has(div ul li.active)").addClass("active");

	$(".accord .header, .accord .answer").on("click", function () {
		var $parent = $(this).closest(".accord");

		if (!$parent.hasClass("active")) {
			$(".accord.active").removeClass("active");
			$parent.addClass("active");
		} else {
			$parent.removeClass("active");
		}
	});
});
